module.exports = __webpack_public_path__ + "img/banner.4e7d4023.jpg";